

///////////////////////////////////
// SEARCH

function initSearch(){
 
    $(".mainNavigationSearchFieldResults").children(".iconButton").click(function(event){
      event.preventDefault();
      $("#form_kesearch_searchfield").submit();
    });
  
    $(".mainNavigationSearchField").find("input[type=text]").on("keyup", function(){

        if($(this).val().length >= 3){
            consolog("autocomplete for.. " + $(this).val());

            var url = $(this).attr("data-url")+$(this).val();        

            $(".mainNavigationSearchFieldResults").html("<ul></ul>");
            var searchStringLength = $(this).val().length;
    
            $.getJSON( url, function(data) {
                
                $(".mainNavigationSearchFieldResults").html("<ul></ul>");

                for (var i = 0; i < data.suggestions.length; i++) {
                    var element = data.suggestions[i];
                    var v1 = element.substr(0,searchStringLength);
                    var v2 = element.substr(searchStringLength);
                    var $li = $("<li searchstring='" + element + "' data-gtm-autosuggest='"+ element + "' tabindex='0'><span data-gtm-autosuggest='"+ element + "'>" + v1 + "</span>" + v2 + "</li>");
                    $li.click(function(){
                        $(".mainNavigationSearchField").find("input[type=text]").val($(this).attr("searchstring"));
                        $("#form_kesearch_searchfield").submit();
                    });
                    $li.on("keydown", handleKeyDownForClick);
                    $(".mainNavigationSearchFieldResults").find("ul").append($li);
                }

                if($(".mainNavigationSearchFieldResults").find("ul").children("li").length > 0){
                    $(".mainNavigationSearchFieldResults").show();
                }
                else{
                    $(".mainNavigationSearchFieldResults").hide();
                }
            });
        
        }
        else{
            $(".mainNavigationSearchFieldResults").hide();
        }
  
    });
}

///////////////////////////////////
// DESCRIPTIONS

function updateDescription(){    

    //consolog("updateDescription()");

    if($(".description").length > 0){

        $(".description").each(function(){
            
            $(this).removeClass("small");
            $(this).removeClass("medium");
            $(this).removeClass("large");
            $(this).removeClass("arrowleft");
            $(this).removeClass("arrowright");

            if($(this).siblings(".descriptionIcon") && $(this).siblings(".descriptionIcon").is(":visible")){

                if($(this).siblings(".descriptionIcon").offset().left < $(window).width()/3 && $(this).parent(".checkboxDescription").length == 0){ 
                    //do not move arrow left on checkbox descriptions
                    $(this).addClass("arrowleft");
                }
                else if($(this).siblings(".descriptionIcon").offset().left < ($(window).width()/3)*2){
                    //centered arrow
                }
                else{
                    $(this).addClass("arrowright");
                }

                if($(this).html().length < 180){
                    $(this).addClass("small");;
                }
                else if($(this).html().length < 500){
                    $(this).addClass("medium");
                }
                else{
                    $(this).addClass("large");
                }
            }
        }); 
    }   
}

///////////////////////////////////
// TOOLTIPS

function initTooltips(){

	if($(".tooltipIcon").length > 0){

		$(".tooltipIcon").each(function(){
		
			if($(this).hasClass("jbox-initialized")){
				return;
			}
			else{

				var content = "html";
				var ttcont = $(this).attr("data-tooltip-content");
				if(ttcont != undefined && ttcont != ""){
					content = "data-tooltip-content"
				}
	
				var mw = Math.round($(window).width()*0.75);
				if(mw > 500){
					mw = 500;
				}
				//https://stephanwagner.me/jBox/
				new jBox('Tooltip', {
					attach: $(this),
					getContent: content,
					maxWidth: mw
				});
				
				$(this).addClass("jbox-initialized");
			}
		});

	}
}    

function updateTooltips(){    

    //consolog("updateTooltips()");

    if($(".tooltipText").length > 0){

        $(".tooltipText").each(function(){
            
            $(this).removeClass("small");
            $(this).removeClass("medium");
            $(this).removeClass("large");
            $(this).removeClass("arrowleft");
            $(this).removeClass("arrowright");

            if($(this).siblings(".tooltipIcon") && $(this).siblings(".tooltipIcon").is(":visible")){

				var pageWidthThird = $(window).width()/3;
				var iconOffsetLeft = $(this).siblings(".tooltipIcon").offset().left;
                
				//arrow pos
				if(iconOffsetLeft < pageWidthThird){ 
                    $(this).addClass("arrowleft");
                }
                else if(iconOffsetLeft > pageWidthThird*2){
					$(this).addClass("arrowright");
                }
                else{
					//centered arrow
                }

                if($(this).html().length < 180){
                    $(this).addClass("small");
                }
                else if($(this).html().length < 500){
                    $(this).addClass("medium");
                }
                else{
                    $(this).addClass("large");
                }
            }
        }); 
    }   
}

///////////////////////////////////
// ARTICLE FILTER

function initArticleFilter() {

    //mobile accordion handling
    if ($(".articleFilterLabel").length > 0) {

        $(".articleFilterLabel").click(function () {
            $(this).toggleClass("active");
            $(this).siblings(".articleFilterContainer").toggle();
        });

    }
    ;

    //checkbox click handling
    if ($(".articleFilterContainer").length > 0) {

        $(".articleFilterContainer").find(".checkboxContainer").click(function () {
            window.location.href = $(this).attr("data-url");
        });
        $(".articleFilterContainer").find(".checkboxContainer").on("keydown", function (e) {
            if ( e.which == 13 ) {
                //key = enter
                window.location.href = $(this).attr("data-url");
            }
        });

    }
    ;
}

//////////////////////////////
// YOUTUBE PLAYER EVENTS

function onYouTubeIframeAPIReady() {

	handleMultipleChoiceYoutubeReadyEvent();
	handleVideoPlayerYoutubeReadyEvent();
}